import { IconProps } from './IconProps';
export function ThoughtsPositive(props: IconProps) {
    return (
        <svg
            {...props}
            width="57"
            height="58"
            viewBox="0 0 57 58"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_5961_67061)">
                <path
                    d="M48.9515 28.9957C49.0962 30.9329 49.2326 32.9097 48.344 34.4002C47.4553 35.8908 45.3221 36.8156 42.4012 36.2011C40.3798 35.7749 37.524 34.9065 35.5237 33.8631C32.5973 32.3372 30.224 30.4423 28.3478 28.2809C26.7588 26.4468 26.3811 24.5763 26.6917 23.0795C27.3231 20.0184 30.9736 18.1864 36.0456 19.1325C41.1219 20.0785 48.6146 24.5067 48.9515 28.9957Z"
                    fill="#80A3FF"
                />
                <path
                    d="M13.813 57.5384C23.8007 57.1737 33.7605 55.8597 43.5127 53.6181C45.8713 53.0741 48.2808 52.4594 50.3303 51.1583C52.3798 49.8572 54.0613 47.7424 54.2519 45.3338C54.351 44.0106 54.009 42.6866 53.4774 41.4773C52.0513 38.1985 49.1552 35.5058 45.6595 34.7219C42.1638 33.9381 38.1703 35.2575 35.6647 38.3771C36.6669 36.9277 35.8208 34.9787 34.9187 33.483C33.9746 31.9071 32.9314 30.3105 31.3486 29.3932C30.0118 28.609 28.418 28.3987 26.8562 28.3614C23.5464 28.2681 19.8696 29.099 17.9546 31.8045C15.9885 34.5808 16.494 38.3164 16.8264 41.7782C15.0635 40.8537 12.8916 40.7733 10.9936 41.4393C9.09567 42.1053 7.48226 43.4537 6.35594 45.1147C5.74477 46.0217 5.26912 47.047 5.16605 48.1385C5.07398 49.1951 5.359 50.2424 5.74755 51.2351C6.43962 53.0024 7.52429 54.6502 9.01306 55.8362C10.5013 56.9933 12.3977 57.5844 13.813 57.5384Z"
                    fill="#CCDAFF"
                />
                <path
                    d="M29.9798 6.78671C30.7865 6.92315 31.5696 6.39208 32.0465 5.73131C32.5234 5.07053 32.801 4.28619 33.2113 3.57738C34.1493 1.97867 36.0685 0.829532 37.8544 1.31281C39.5765 1.78295 40.6497 3.64271 40.7205 5.42737C40.7491 6.03518 40.6819 6.66746 40.8903 7.243C41.3286 8.43478 42.7142 8.895 43.9004 9.34059C45.3801 9.89147 46.9476 10.8373 47.2518 12.3955C47.4442 13.3947 47.0347 14.4509 46.3168 15.1657C45.599 15.8804 44.6123 16.2798 43.6082 16.4288C42.3485 16.6135 40.8736 16.5065 40.0168 17.45C39.5753 17.9313 39.4082 18.6005 39.1661 19.2053C38.6817 20.415 37.718 21.5497 36.4316 21.7329C35.0326 21.9286 33.649 20.8497 33.2279 19.4932C32.8134 18.1591 33.141 16.601 32.3832 15.4319C31.0901 13.4489 27.5843 13.9321 26.4513 11.8495C26.1872 11.3655 26.1041 10.8019 26.1382 10.2545C26.2771 8.18832 28.3148 6.50456 29.9798 6.78671Z"
                    fill="#121A44"
                />
            </g>
            <defs>
                <clipPath id="clip0_5961_67061">
                    <rect
                        width="57"
                        height="57"
                        fill="white"
                        transform="translate(0 0.736328)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
